<script>
	import Alert from './Layout/Alert.svelte';
	import API from '../States/API';
	import Cookie from './Layout/Cookie.svelte';
	import Data from '../States/Data';
	import Header from './Layout/Header.svelte';
	import Helper from '../Models/Helper';
	import Footer from './Layout/Footer.svelte';
	import Menu from './Layout/Menu.svelte';
	import Router from '../States/Router';
	import Slides from './Layout/Slides.svelte';
	import {onMount} from 'svelte';

	let loaded = false;

	onMount(() => {
		window.onunhandledrejection = error => {
			console.error(error);
		};
	});

	function html() {
		const html = jQuery('html');
		html.addClass($Data.version.code);
		html.addClass('loaded');
	}

	function scripts() {
		if ($API.active && !Helper.app()) {
			Helper.script('https://kit.fontawesome.com/65f342d24c.js');
			Helper.script(`https://www.googletagmanager.com/gtag/js?id=${$Data.version.ga}`);
		}
	}

	async function init() {
		await Data.init();
		Router.init();
	}

	Data.subscribe(state => {
		if (!loaded && state.batch_loaded) {
			loaded = true;
			html();
			scripts();
		}
	});

	init();
</script>

<Header/>
<Menu/>
<Slides/>
<Cookie/>
<Alert/>
<Footer/>